<template>
  <div style="height: 56px; margin-top: 20px;text-align: center;color: #797C86">
    <img src="@/assets/web/copyright.png" />
      ICP备案/许可证号：闽ICP备2021017535号 ©2023 莆田市数字集团有限公司 版权所有
  </div>
</template>

<script>
export default {
  name: 'Copyright'
}
</script>

<style scoped></style>
